import HttpClientToken from '../../services/HttpClientToken';
import { AxiosError } from 'axios';

import { GenerarListaEstradosResponse, DetalleListaEstradosResponse, PublicarListaEstradosParams, PublicarListaEstradosResponse, FinalizarListaEstradosParams, FinalizarListaEstradosResponse, BuscarListaEstradosParams, BuscarListaEstradosResponse, defaultBuscarListaEstrados, defaultDetalleListaEstrados, defaultFinalizarListaEstrados, defaultGenerarListaEstrados, defaultPublicarListaEstrados } from '../../interfaces/tribunal/ListaEstradosInterface';

export const GenerarListaEstrados = () => {

    return new Promise<GenerarListaEstradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaEstrados/Generar', {}, token)
            .then( ({ data } : { data : GenerarListaEstradosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarListaEstrados, message: error.message } );
            });

        }

    });

}

export const DetalleListaEstrados = ( params: { idListaEstrados: string } ) => {

    return new Promise<DetalleListaEstradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaEstrados/Detalle', params, token)
            .then( ({ data } : { data : DetalleListaEstradosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultDetalleListaEstrados, message: error.message } );
            });

        }

    });

}

export const PublicarListaEstrados = ( params: PublicarListaEstradosParams ) => {

    return new Promise<PublicarListaEstradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaEstrados/Publicar', params, token)
            .then( ({ data } : { data : PublicarListaEstradosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultPublicarListaEstrados, message: error.message } );
            });

        }

    });

}

export const FinalizarListaEstrados = ( params: FinalizarListaEstradosParams ) => {

    return new Promise<FinalizarListaEstradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaEstrados/Finalizar', params, token)
            .then( ({ data } : { data : FinalizarListaEstradosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultFinalizarListaEstrados, message: error.message } );
            });

        }

    });

}

export const BuscarListaEstrados = ( params: BuscarListaEstradosParams ) => {

    return new Promise<BuscarListaEstradosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaEstrados/Buscar', params, token)
            .then( ({ data } : { data : BuscarListaEstradosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultBuscarListaEstrados, message: error.message } );
            });

        }

    });

}
